import SbUtils from '../../Utils/SbUtils'

const Type = (props) => {

    return (
        <div
            className={'sb-type-item' + (props?.customClass ? ' ' + props?.customClass : '')}
            data-checked={props.isChecked}
            data-ispro={props.isFeedTypePro}
            data-type={props.type}
            onClick={() => {
                if (props?.onClick)
                    props.onClick()
            }}
        >
            {props.isChecked &&
                SbUtils.printIcon('checked', 'sb-type-checked-svg')
            }

            <div className='sb-type-icon sb-fs'>
                {SbUtils.printIcon(props.type, 'sb-type-svg')}
            </div>

            <div className='sb-type-info-wrap sb-fs'>
                <div className='sb-type-name sb-bold sb-text-small'>
                    {props.title}
                    {
                        props.isFeedTypePro &&
                        SbUtils.printIcon('rocket', 'sb-type-name-svg', false, 12)
                    }
                </div>
                {props.info &&
                    <div className='sb-type-info sb-text-tiny'>
                        {props.info}
                    </div>
                }
            </div>
        </div>
    )
}

export default Type;
